import {fullReady} from "@webreact/webreactor";

__webpack_public_path__ = document.head.querySelector('meta[name="base_assets"]').content;

/**
 * Fire this function when the document is fully loaded.
 * It takes no parameters and should return nothing.
 *
 * @return void
 */
function loaded() {

    const sidebar = document.querySelector('.sidebar-inner');

    if (sidebar) {
        document.addEventListener('facetwp-loaded', setStickyIfFits.bind(null, sidebar));
        document.addEventListener('facetwp-refresh', setStickyIfFits.bind(null, sidebar));
    }

}

const setStickyIfFits = (sidebar) => {
    const headerHeight = document.querySelector('#header-outer').clientHeight;

    if (sidebar.clientHeight < (window.innerHeight - headerHeight)) {
        sidebar.classList.add('sticky');
    } else {
        sidebar.classList.remove('sticky');
    }
}

(function($) {
    $(document).on('facetwp-loaded', function() {
        $('.facetwp-facet').each(function() {
            var facet = $(this);
            var facet_name = facet.attr('data-name');
            var facet_type = facet.attr('data-type');
            var facet_label = FWP.settings.labels[facet_name];
            if (facet_type !== 'pager' && facet_type !== 'sort') {
                if (('undefined' === typeof FWP.settings.num_choices[facet_name] ||
                    ('undefined' !== typeof FWP.settings.num_choices[facet_name] && FWP.settings.num_choices[facet_name] > 0)) && $('.facet-label[data-for="' + facet_name + '"]').length < 1) {
                    facet.before('<h3 class="facet-label" data-for="' + facet_name + '">' + facet_label + '</h3>');
                } else if ('undefined' !== typeof FWP.settings.num_choices[facet_name] && !FWP.settings.num_choices[facet_name] > 0) {
                    $('.facet-label[data-for="' + facet_name + '"]').remove();
                }
            }
        });
    });
})(jQuery);

fullReady(loaded);
